import { motion } from "framer-motion";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden pt-52">
      <main className="relative">
        {/* Hero Section */}
        <section className="pt-32 pb-20 relative overflow-hidden">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <motion.div
              className="text-center space-y-8"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <motion.div
                className="space-y-6"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <h1 className="text-4xl lg:text-6xl leading-tight text-foreground">
                  <span className="bg-gradient-to-r from-slate-800 via-slate-700 to-cyan-600 bg-clip-text text-transparent">
                    Terms of Use
                  </span>
                </h1>
                <p className="text-lg text-muted-foreground">
                  Last updated: January 2025
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Content Section */}
        <section className="pb-20 relative overflow-hidden">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <motion.div
              className="prose prose-slate max-w-none"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <div className="bg-white border border-slate-200/60 rounded-xl p-8 lg:p-12 shadow-lg space-y-8">
                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Agreement to Terms</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    By accessing and using this website, you accept and agree to be bound by the terms and provision 
                    of this agreement. If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Use License</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>Permission is granted to temporarily download one copy of the materials on Z Creative Partners' 
                    website for personal, non-commercial transitory viewing only. This is the grant of a license, not a 
                    transfer of title, and under this license you may not:</p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Modify or copy the materials</li>
                      <li>Use the materials for any commercial purpose or for any public display (commercial or non-commercial)</li>
                      <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                      <li>Remove any copyright or other proprietary notations from the materials</li>
                    </ul>
                    <p>This license shall automatically terminate if you violate any of these restrictions and may be 
                    terminated by Z Creative Partners at any time.</p>
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Disclaimer</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>The materials on Z Creative Partners' website are provided on an 'as is' basis. Z Creative Partners 
                    makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, 
                    without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, 
                    or non-infringement of intellectual property or other violation of rights.</p>
                    <p>Further, Z Creative Partners does not warrant or make any representations concerning the accuracy, 
                    likely results, or reliability of the use of the materials on its website or otherwise relating to such 
                    materials or on any sites linked to this site.</p>
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Limitations</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    In no event shall Z Creative Partners or its suppliers be liable for any damages (including, without 
                    limitation, damages for loss of data or profit, or due to business interruption) arising out of the use 
                    or inability to use the materials on Z Creative Partners' website, even if Z Creative Partners or a 
                    Z Creative Partners authorized representative has been notified orally or in writing of the possibility 
                    of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations 
                    of liability for consequential or incidental damages, these limitations may not apply to you.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Accuracy of Materials</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    The materials appearing on Z Creative Partners' website could include technical, typographical, or 
                    photographic errors. Z Creative Partners does not warrant that any of the materials on its website 
                    are accurate, complete, or current. Z Creative Partners may make changes to the materials contained 
                    on its website at any time without notice. However, Z Creative Partners does not make any commitment 
                    to update the materials.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Links</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Z Creative Partners has not reviewed all of the sites linked to our website and is not responsible 
                    for the contents of any such linked site. The inclusion of any link does not imply endorsement by 
                    Z Creative Partners of the site. Use of any such linked website is at the user's own risk.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Modifications</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Z Creative Partners may revise these terms of service for its website at any time without notice. 
                    By using this website, you are agreeing to be bound by the then current version of these terms of service.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Governing Law</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    These terms and conditions are governed by and construed in accordance with the laws of Singapore 
                    and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Privacy Policy</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the site, 
                    to understand our practices.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">User Content</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>Our services may allow you to submit content. You retain ownership of any content you submit, 
                    but you grant us a worldwide, royalty-free license to use, display, and distribute your content 
                    in connection with our services.</p>
                    <p>You are responsible for ensuring that any content you submit:</p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Does not violate any laws or regulations</li>
                      <li>Does not infringe on the rights of others</li>
                      <li>Is not harmful, offensive, or inappropriate</li>
                      <li>Does not contain viruses or malicious code</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Service Availability</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    We strive to provide uninterrupted access to our website and services, but we cannot guarantee 
                    that our services will always be available or error-free. We reserve the right to modify, 
                    suspend, or discontinue any aspect of our services at any time.
                  </p>
                </div>

                <div className="border-t border-slate-200/60 pt-8">
                  <h2 className="text-2xl lg:text-3xl text-foreground mb-4">Contact Information</h2>
                  <div className="text-muted-foreground space-y-2">
                    <p>If you have any questions about these Terms of Use, please contact us:</p>
                    <div className="space-y-1">
                      <p><strong>Email:</strong> info@z-creative-partners.com</p>
                      <p><strong>Address:</strong> KS Building 5F, 3-16-12 Roppongi, Minato City, Tokyo, Japan</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
    </div>
  );
}